export const isTextContainHebrew = input => /[\u0590-\u05FF]/.test(input);
